export default __webpack_public_path__ + "97240966fbf7716054a26843dff578ea.png";